import { useTheme } from "../../../utils/ThemeContext";
const ButtonCard = ({
  title,
  count,
  iconActive,
  iconInactive,
  active,
  totalCount,
  setActiveTab,
  value,
}) => {
  const { theme } = useTheme();
  console.log("Total Count:", title, totalCount);
  return (
    <div
      className="flex-direction-row gap-8 items-center justify-between pointer button-card"
      style={{
        backgroundColor: active ? "var(--navbar-bg)" : "var(--event-buttons)",
      }}
      onClick={() => setActiveTab(value)}
    >
      <div className="flex-direction-row items-center gap-12 button-card-title">
        <img
          src={active ? iconActive : iconInactive}
          width={38}
          height={38}
          alt="icon"
        />
        <p
          className="font-16 inria-sans-700"
          style={{
            color: active ? "var(--Navbar-active)" : "var(--text-gray)",
          }}
        >
          {title}
        </p>
      </div>
      <div
        className="flex-direction-row gap-6 font-20 inria-sans-700 button-card-count"
        style={{
          color: active ? "var(--Navbar-active)" : "var(--text-gray)",
        }}
      >
        <p style={{ color: totalCount && active && "var(--Yellow-1)" }}>
          {count}
        </p>
        {totalCount !== undefined && (
          <div className="flex-direction-row gap-4">
            <span>/</span> <p>{totalCount}</p>{" "}
          </div>
        )}
      </div>
    </div>
  );
};
export default ButtonCard;
